<div class="page requests">
  <h1 class="c-h1">{{ 'MENU.requests-overview-title' | translate }}</h1>

  <myabvv-unemployment-end-date></myabvv-unemployment-end-date>

  <div class="mb-8">
    <myabvv-introduction [introduction]="'DOCUMENTS.requests.download_and_print' | translate"></myabvv-introduction>
  </div>

  @if (state$ | async; as state) {
    <myabvv-filter [isLoading]="state.loading" (applyFilterEvent)="onApplyFilter()" (reinitializeFiltersEvent)="onReinitializeFilters()">
      <myabvv-date-filter class="l-grid__unit  l-grid__unit--6of12@medium" [datePickerOptionsDate]="datePickerOptionsStartDate" (changeDateEvent)="onChangeStartDate($event)" [date]="startDate" [label]="'CALENDAR.from' | translate"></myabvv-date-filter>
      <myabvv-date-filter class="l-grid__unit  l-grid__unit--6of12@medium" [datePickerOptionsDate]="datePickerOptionsEndDate" (changeDateEvent)="onChangeEndDate($event)" [date]="endDate" [label]="'CALENDAR.till' | translate"></myabvv-date-filter>
    </myabvv-filter>

    @if (!state.loading && state.data && state.data.paymentRequests.length === 0 && !state.error) {
      <div class="info-card-empty">
        <i class="fa fa-inbox info-card-empty__icon"></i>
        <span>{{ 'DOCUMENTS.requests.no_data' | translate }}</span>
      </div>
    }
    <myabvv-alert [condition]="isDownloading()" [message]="'USER_FEEDBACK.download_progress'" [type]="'success'"></myabvv-alert>
    <myabvv-alert [condition]="state.error" [message]="'USER_FEEDBACK.error_occurred'" [type]="'error'"></myabvv-alert>
    <myabvv-alert [condition]="hasDownloadError()" [message]="'USER_FEEDBACK.download_error'" [type]="'error'"></myabvv-alert>
    @if (state.loading) {
      <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
    }

    @if (!state.loading && state.data && state.data.paymentRequests.length > 0) {
      <!-- Timeline View -->
      <div class="relative mb-8">
        @for (paymentRequest of pagedRequests(); track paymentRequest.requestDate + '#' + paymentRequest.requestSequence; let isFirst = $first; let isLast = $last) {
          <div class="timeline-item flex gap-4 md:gap-6 relative">
            <!-- Timeline connector -->
            <div class="flex flex-col items-center w-[30px] md:w-[44px] shrink-0">
              <div class="timeline-line w-[1px] md:w-0.5 flex-1 min-h-4" [class.invisible]="isFirst"></div>
              <div class="timeline-dot flex items-center justify-center w-[30px] h-[30px] md:w-[44px] md:h-[44px] rounded-full text-white text-[1.1rem] md:text-[1.4rem] shrink-0 z-[1] shadow-md"
                   [ngClass]="getStatusDotClass(paymentRequest.requestState)">
                <i class="fa" [ngClass]="getStatusIcon(paymentRequest.requestState)"></i>
              </div>
              <div class="timeline-line w-[1px] md:w-0.5 flex-1 min-h-4" [class.invisible]="isLast"></div>
            </div>

            <!-- Timeline content -->
            <div class="timeline-content flex-1 rounded-[10px] mb-4 md:mb-6 overflow-hidden transition-all duration-200 shadow-sm hover:shadow-md">
              <!-- Header row: Date + Status -->
              <div class="timeline-header flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-4 p-4 md:px-5">
                <div class="text-[1.5rem] md:text-[1.6rem] font-bold text-neutral-08 dark:text-myabvvdark-00">
                  {{paymentRequest.requestDate | date: 'dd/MM/yyyy'}}
                </div>
                <span class="timeline-status inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[1.2rem] font-semibold whitespace-nowrap w-full md:w-auto justify-center md:justify-start"
                      [ngClass]="getStatusBadgeClass(paymentRequest.requestState)">
                  {{ getTranslatedData(paymentRequest.requestStateDescription) }}
                </span>
              </div>

              <!-- Main info -->
              <div class="p-4 md:p-5">
                <!-- Type -->
                @if (getRequestType(paymentRequest); as requestType) {
                  <div class="timeline-type text-[1.4rem] md:text-[1.5rem] font-semibold mb-3 md:mb-4 pb-3 md:pb-4 border-b border-dashed">
                    {{requestType}}
                  </div>
                }

                <!-- Action indicators -->
                @if (paymentRequest.positiveDecision) {
                <div class="flex flex-col md:flex-row flex-wrap gap-3">
                  <button class="timeline-action--pdf inline-flex items-center justify-center md:justify-start gap-2 py-2.5 md:py-2 px-4 md:px-3.5 rounded-md text-[1.3rem] font-medium cursor-pointer transition-all duration-200 border w-full md:w-auto"
                          [class.opacity-50]="isDownloading()"
                          [class.cursor-not-allowed]="isDownloading()"
                          (click)="!isDownloading() && downloadRequest(paymentRequest); $event.stopPropagation()">
                    <i class="fa fa-file-pdf"></i>
                    <span>PDF</span>
                  </button>
                </div>
                }

                <!-- Missing documents and comment inline -->
                @if (getUnemploymentApplication(state.data.unemploymentApplications, paymentRequest.requestDate, paymentRequest.requestState, paymentRequest.requestSequence); as application) {
                  @if (hasMissingDocuments(application)) {
                    <myabvv-incomplete-request-info
                      class="mt-3"
                      [documents]="application.documents"
                      [comment]="application.text">
                    </myabvv-incomplete-request-info>
                  } @else if (application.text?.trim()) {
                    <p class="timeline-comment mt-3 mb-0 text-[1.4rem] md:text-[1.5rem] leading-normal">{{ application.text }}</p>
                  }
                }
              </div>
            </div>
          </div>
        }
      </div>

      <myabvv-pagination [pages]="pages()" [activePage]="currentPage()" (selectPageEvent)="onPageChange($event)"></myabvv-pagination>
    }
  }
</div>
